import { IAuthState } from '../../contexts';

const useSubscribeInCheckout = (useAuthentication: () => IAuthState) => {
  const { isMemberProspect, isLoading } = useAuthentication();

  return {
    isSubscriptionAvailable: Boolean(isMemberProspect),
    isLoading,
  };
};

export { useSubscribeInCheckout };
